import { icons } from "@/ui";

const toastIcons = {
  info: <icons.InformationCircleIcon className="size-5 text-accent" />,
  success: <icons.CheckCircleIcon className="size-5 text-success" />,
  warning: <icons.ExclamationCircleIcon className="size-5 text-warning" />,
  error: <icons.XCircleIcon className="size-5 text-danger" />,
};

export default toastIcons;
